export default __webpack_public_path__ + "static/media/cybertrainW.67978759.png";